/**
 * Maarlab's `payment.payment_type` values, used only by conditions whose `conditionType` is
 * `FLIGHT_HOTEL`. These three values are fixed by Maarlab's API — do not invent others.
 */
export enum FlightHotelPaymentType {
  FLIGHT_ONLY = "FLIGHT_ONLY",
  ALL_NOW = "ALL_NOW",
  FLIGHT_NOW_HOTEL_LATER = "FLIGHT_NOW_HOTEL_LATER",
}
